import { render, staticRenderFns } from "./LotCard.vue?vue&type=template&id=fa0361d2&scoped=true&"
import script from "./LotCard.vue?vue&type=script&lang=js&"
export * from "./LotCard.vue?vue&type=script&lang=js&"
import style0 from "./LotCard.vue?vue&type=style&index=0&id=fa0361d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0361d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCol,VContainer,VRow,VTooltip})
